export default "__VITE_ASSET__fvmgWmE7__"